import usersIcon from "../../../../../assets/icons/user-green.webp";
import viewIcon from "../../../../../assets/icons/view.webp";

export const getTypeIcon = (type: string) => {
  switch (type.toLowerCase()) {
    case "users":
      return usersIcon;
    case "views":
      return viewIcon;
    default:
      return undefined;
  }
};
